import {combineReducers} from '@ngrx/store';
import {paymentInvoicesFeatureKey, paymentInvoicesReducer, PaymentInvoicesState} from './payment-invoice-documents/_store/payment-invoice.reducer';
import {accrualTemplatesFeatureKey, accrualTemplatesReducer, AccrualTemplatesState} from './accrual/accrual-template/_store/accrual-template.reducer';
import {staffListDocumentsFeatureKey, staffListDocumentsReducer, StaffListDocumentsState} from './staff-list-document/_store/staff-list-document.reducer';
import {nomenclatureDocumentsFeatureKey, nomenclatureDocumentsReducer, NomenclatureDocumentsState} from './nomenclature-documents/_store/nomenclature-documents.reducer';
import {countersIndicationsFeatureKey, countersIndicationsReducer, CountersIndicationsState} from './accrual/counters-indications/_store/counter-indications.reducer';
import {staffEmployeesFeatureKey, staffEmployeesReducer, StaffEmployeesState} from './references/staff-employee/_store/staff-employee.reducer';
import {nomenclatureFeatureKey, nomenclatureReducer, NomenclatureState} from './references/nomenclature/_store/nomenclature.reducer';
import {assetFeatureKey, assetReducer, AssetState} from './references/asset/_store/asset.reducer';
import {companyFeatureKey, companyReducer, CompanyState} from './references/company/_store/company.reducer';
import {accrualDocumentsFeatureKey, accrualDocumentsReducer, AccrualDocumentsState} from './accrual/accrual-documents/_store/accrual-documents.reducer';
import {adjustmentsFeatureKey, adjustmentsReducer, AdjustmentsState} from './accrual/adjustment/_store/adjustment.reducer';
import {staffPositionFeatureKey, staffPositionReducer, StaffPositionState} from '@accounting/references/staff-position/_store/staff-position.reducer';
import {flowItemFeatureKey, flowItemReducer, FlowItemState} from "./references/flow-item/_store/flow-item.reducer";
import {staffPersonFeatureKey, staffPersonReducer, StaffPersonState} from "@accounting/references/staff-person/_store/staff-person.reducer";
import {nomenclatureStorageFeatureKey, nomenclatureStorageReducer, NomenclatureStorageState} from "@accounting/references/nomenclature-storage/_store/nomenclature-storage.reducer";
import {accountFeatureKey, accountReducer, BalanceAccountState} from "@accounting/references/balance-account/_store/account.reducer";
import {moneyTransactionsFeatureKey, moneyTransactionsReducer, MoneyTransactionsState} from '@accounting/money/money-transaction/_store/money-transactions.reducer';
import {assetWriteOffsFeatureKey, assetWriteOffsReducer, AssetWriteOffsState} from '@accounting/asset-write-off/_store/asset-write-off.reducer';
import {assetDocumentsFeatureKey, assetDocumentsReducer, AssetDocumentsState} from "@accounting/asset-document/_store/asset-document.reducer";
import {kitDocumentsFeatureKey, kitDocumentsReducer, KitDocumentsState} from "@accounting/kit-document/_store/kit-document.reducer";
import {accountingEntriesFeatureKey, accountingEntriesReducer, AccountingEntriesState} from "@accounting/operations/accounting-entry/_store/accounting-entry.reducer";
import {wageAccrualsFeatureKey, wageAccrualsReducer, WageAccrualsState} from "@accounting/wage-documents/wage-accrual/_store/wage-accrual.reducer";
import {wagePaymentsFeatureKey, wagePaymentsReducer, WagePaymentsState} from "@accounting/wage-documents/wage-payment/_store/wage-payment.reducer";
import {periodResultsFeatureKey, periodResultsReducer, PeriodResultsState} from "@accounting/operations/period-result/_store/period-result.reducer";
import {inventoryActFeatureKey, inventoryActsReducer, InventoryActsState} from "@accounting/inventory-act/_store/inventory-act.reducer";
import {powerOfAttorneyFeatureKey, powerOfAttorneysReducer, PowerOfAttorneysState} from "@accounting/powerofattorney/_store/powerofattorney.reducer";
import {staffDocumentsFeatureKey, staffDocumentsReducer, StaffDocumentsState} from '@accounting/staff-documents/_store/staff-documents.reducer';
import {companyActFeatureKey, companyActsReducer, CompanyActsState} from "@accounting/company-act/_store/company-act.reducer";
import {unitFeatureKey, unitReducer, UnitState} from "@accounting/references/units/_store/units.reducer";
import {tariffsFeatureKey, tariffsReducer, TariffsState} from "@accounting/accrual/tariff/_store/tariff.reducer";
import {calendarsFeatureKey, calendarsReducer, CalendarsState} from "@accounting/calendar/_store/calendar.reducer";
import {calendarSchedulesFeatureKey, calendarSchedulesReducer, CalendarSchedulesState} from "@accounting/calendar-schedule/_store/calendar-schedule.reducer";
import {taxReportFeatureKey, taxReportReducer, TaxReportState} from "@accounting/tax-reports/_store/tax-reports.reducer";
import {initialsApartmentFeatureKey, initialsApartmentReducer, InitialsApartmentState} from "@accounting/initials/apartment/_store/apartment.reducer";
import {scheduledTasksFeatureKey, scheduledTasksReducer, ScheduledTaskState} from "@accounting/scheduled-tasks/_store/scheduled-tasks.reducer";
import {moneyAccountsFeatureKey, moneyAccountsReducer, MoneyAccountsState} from "@accounting/money/money-dictionaries/money-accounts/_store/money-accounts.reducer";
import {batchAuditsFeatureKey, batchAuditsReducer, BatchAuditsState} from "@accounting/batch-audit/_store/batch-audit.reducer";
import {estimateFeatureKey, estimatesReducer, EstimatesState} from "@accounting/accrual/estimate/_store/estimate.reducer";
import {showcaseFeatureKey, showcaseReducer, ShowcaseState} from "@accounting/accrual/showcase/_store/showcase.reducer";

export const accountingFeatureKey = 'accounting';

export interface AccountingState {
    [accrualDocumentsFeatureKey]: AccrualDocumentsState,
    [adjustmentsFeatureKey]: AdjustmentsState,
    [tariffsFeatureKey]: TariffsState,
    [showcaseFeatureKey]: ShowcaseState,
    [accrualTemplatesFeatureKey]: AccrualTemplatesState,
    [countersIndicationsFeatureKey]: CountersIndicationsState,

    [moneyTransactionsFeatureKey]: MoneyTransactionsState,
    [accountingEntriesFeatureKey]: AccountingEntriesState,
    [periodResultsFeatureKey]: PeriodResultsState,
    [wageAccrualsFeatureKey]: WageAccrualsState,
    [wagePaymentsFeatureKey]: WagePaymentsState,

    [nomenclatureDocumentsFeatureKey]: NomenclatureDocumentsState
    [paymentInvoicesFeatureKey]: PaymentInvoicesState
    [staffListDocumentsFeatureKey]: StaffListDocumentsState,
    [assetDocumentsFeatureKey]: AssetDocumentsState,
    [kitDocumentsFeatureKey]: KitDocumentsState,
    [assetWriteOffsFeatureKey]: AssetWriteOffsState,

    [inventoryActFeatureKey]: InventoryActsState,
    [companyActFeatureKey]: CompanyActsState,
    [powerOfAttorneyFeatureKey]: PowerOfAttorneysState,

    [staffEmployeesFeatureKey]: StaffEmployeesState,
    [nomenclatureFeatureKey]: NomenclatureState,
    [assetFeatureKey]: AssetState,
    [companyFeatureKey]: CompanyState,
    [staffPositionFeatureKey]: StaffPositionState,
    [flowItemFeatureKey]: FlowItemState,
    [staffPersonFeatureKey]: StaffPersonState,
    [nomenclatureStorageFeatureKey]: NomenclatureStorageState,
    [accountFeatureKey]: BalanceAccountState,
    [unitFeatureKey]: UnitState,

    [staffDocumentsFeatureKey]: StaffDocumentsState,
    [moneyAccountsFeatureKey]: MoneyAccountsState,

    [calendarsFeatureKey]: CalendarsState,
    [calendarSchedulesFeatureKey]: CalendarSchedulesState,
    [taxReportFeatureKey]: TaxReportState,
    [initialsApartmentFeatureKey]: InitialsApartmentState,
    [scheduledTasksFeatureKey]: ScheduledTaskState,

    [batchAuditsFeatureKey]: BatchAuditsState,

    [estimateFeatureKey]: EstimatesState
}

export const accountingReducers = combineReducers({
    [accrualDocumentsFeatureKey]: accrualDocumentsReducer,
    [adjustmentsFeatureKey]: adjustmentsReducer,
    [tariffsFeatureKey]: tariffsReducer,
    [showcaseFeatureKey]: showcaseReducer,
    [accrualTemplatesFeatureKey]: accrualTemplatesReducer,
    [countersIndicationsFeatureKey]: countersIndicationsReducer,

    [moneyTransactionsFeatureKey]: moneyTransactionsReducer,
    [accountingEntriesFeatureKey]: accountingEntriesReducer,
    [periodResultsFeatureKey]: periodResultsReducer,
    [wageAccrualsFeatureKey]: wageAccrualsReducer,
    [wagePaymentsFeatureKey]: wagePaymentsReducer,

    [nomenclatureDocumentsFeatureKey]: nomenclatureDocumentsReducer,
    [paymentInvoicesFeatureKey]: paymentInvoicesReducer,
    [staffListDocumentsFeatureKey]: staffListDocumentsReducer,
    [assetDocumentsFeatureKey]: assetDocumentsReducer,
    [kitDocumentsFeatureKey]: kitDocumentsReducer,
    [assetWriteOffsFeatureKey]: assetWriteOffsReducer,

    [inventoryActFeatureKey]: inventoryActsReducer,
    [companyActFeatureKey]: companyActsReducer,
    [powerOfAttorneyFeatureKey]: powerOfAttorneysReducer,

    [staffEmployeesFeatureKey]: staffEmployeesReducer,
    [nomenclatureFeatureKey]: nomenclatureReducer,
    [assetFeatureKey]: assetReducer,
    [companyFeatureKey]: companyReducer,
    [staffPositionFeatureKey]: staffPositionReducer,
    [flowItemFeatureKey]: flowItemReducer,
    [staffPersonFeatureKey]: staffPersonReducer,
    [nomenclatureStorageFeatureKey]: nomenclatureStorageReducer,
    [accountFeatureKey]: accountReducer,
    [unitFeatureKey]: unitReducer,

    [staffDocumentsFeatureKey]: staffDocumentsReducer,
    [moneyAccountsFeatureKey]: moneyAccountsReducer,

    [calendarsFeatureKey]: calendarsReducer,
    [calendarSchedulesFeatureKey]: calendarSchedulesReducer,
    [taxReportFeatureKey]: taxReportReducer,
    [initialsApartmentFeatureKey]: initialsApartmentReducer,
    [scheduledTasksFeatureKey]: scheduledTasksReducer,

    [batchAuditsFeatureKey]: batchAuditsReducer,

    [estimateFeatureKey]: estimatesReducer
});
